import { styled } from "@mui/material";
import { CSSProperties } from "react";

const DotContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  "@keyframes bouncing-loader": {
    to: {
      transform: "translateY(-1em)"
    }
  },
  "> div:nth-of-type(2)": {
    animationDelay: "0.2s"
  },
  "> div:nth-of-type(3)": {
    animationDelay: "0.4s"
  }
});

const Dot = styled("div")<{ isLoading?: boolean }>(({ theme, isLoading }) => ({
  width: "1em",
  height: "1em",
  margin: "0.5em 1em",
  borderRadius: "50%",
  backgroundColor: theme.palette.autostoreRed.main,
  animation: isLoading ? "bouncing-loader 0.6s infinite alternate" : "none"
}));

type Props = {
  /** If true, dots will animate. If false, will be static. Defaults to true. */
  isLoading?: boolean;
  /** CSS style for the dots */
  dotStyle?: CSSProperties;
};

export const BouncingDotsLoader = ({ isLoading = true, dotStyle }: Props) => (
  <DotContainer role="progressbar">
    <Dot isLoading={isLoading} sx={dotStyle} aria-label="dot" />
    <Dot isLoading={isLoading} sx={dotStyle} aria-label="dot" />
    <Dot isLoading={isLoading} sx={dotStyle} aria-label="dot" />
  </DotContainer>
);
